<template>
  <!-- 支払明細登録 -->
  <div class="egl-dialog-elm">
    <el-dialog
      :title="dialogTitle"
      :visible="isShow"
      class="egl-dialog payment-registration-dialog"
      :modal="false"
      :before-close="closeDialog"
      :modal-append-to-body="true"
      :show-close="true"
      :close-on-click-modal="false"
    >
      <el-form :disabled="actionType == 'view' ? true : false" label-position="top">
        <div class="module-item base-info">
          <div class="module-item-tit">{{ $locale("accountPayable.accountPayableDetailBasicInformation") }}</div>
          <el-row :gutter="25">
            <el-col :span="4">
              <el-form-item :label="$locale('accountPayable.accountPayableDetail') + '*'">
                <el-input v-model="basicInfo.name" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="$locale('accountPayable.th.requestDeadDate') + '*'">
                <el-input v-model="basicInfo.requestDeadDateText" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="$locale('accountPayable.th.paymentDueDate')">
                <el-input v-model="basicInfo.payDateText" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :label="$locale('accountPayable.th.recordAmount') + '/' + $locale('accountPayable.invoiceAmount') + '*'">
                <el-input v-model="basicInfo.needPayAmountText" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="module-item">
          <div class="module-item-tit">{{ $locale("accountPayable.paymentDetailBasicInformation") }}</div>

          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item :label="$locale('accountPayable.paymentName') + '*'">
                <el-input v-model="form.name" @input="() => setSaveBtn()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="`${$locale('accountPayable.paymentDate')}*`">
                <CommDatePicker
                  v-model="form.date"
                  :value.sync="form.date"
                  width="100%"
                  :showWeekly="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="`${$locale('accountPayable.paymentCategory')}1*`">
                <el-select v-model="form.type" @change="changeType">
                  <el-option
                    v-for="item in typeOption"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item :label="`${$locale('accountPayable.paymentCategory')}2*`">
                <el-select v-model="form.typeDetail" @change="changeTypeDetail">
                  <el-option
                    v-for="item in typeDetailOption"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="`${$locale('accountPayable.paymentTotal')}*`">
                <el-input v-model="paymentTotal" :placeholder="$locale('accountPayable.placeholder.paymentTotal')" @input="inputPaymentTotal" @blur="blurPaymentTotal"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-button class="egl-btn-yellow" @click="copyAllTrPayable">{{ $locale("accountPayable.copyPayable") }}</el-button>
            </el-col>
            <el-col :span="4" :offset="8" v-if="form.type == 'OFFSET'">
              <el-form-item>
                <el-select v-model="form.payOffset.offsetDetailId" @change="changePayOffset">
                  <el-option
                    v-for="(item, index) in payOffsetCinemaOption"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-table
            :data="tableData"
            class="egl-table"
            stripe
            :cell-class-name="setCellClassName"
            v-if="tableData.length > 0"
          >
            <el-table-column :label="$locale('global.cinemaName')" prop="cinemaName"></el-table-column>
            <el-table-column :label="$locale('accountPayable.customerName')" prop="clientName"></el-table-column>
            <el-table-column :label="$locale('global.titleOfWork')" prop="filmName" v-if="accountPayableMsg.type == 'TICKETING'"></el-table-column>
            <el-table-column :label="$locale('accountPayable.productName')" prop="storeName" v-else-if="accountPayableMsg.type == 'BUY' || accountPayableMsg.type == 'PROXY_BUY'"></el-table-column>

            <el-table-column :label="$locale('accountPayable.targetPeriod')" prop="dateInterval"></el-table-column>

            <el-table-column :label="$locale('accountPayable.income')" v-if="accountPayableMsg.type == 'TICKETING'">
              <template slot-scope="scope">{{ scope.row.incomeTotal.toLocaleString() }}</template>
            </el-table-column>
            <el-table-column :label="$locale('accountPayable.mobilization')" v-if="accountPayableMsg.type == 'TICKETING'">
              <template slot-scope="scope">{{ scope.row.actualNumberTotal.toLocaleString() }}</template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.th.recordAmount')">
              <template slot-scope="scope">{{ scope.row.needPayAmount.toLocaleString() }}</template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.th.amountPaid')">
              <template slot-scope="scope">{{ scope.row.payAmount.toLocaleString() }}</template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.payMoney')">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.payMoney"
                  v-if="scope.$index != tableData.length - 1"
                  @input="tdInputNumber('tableData', scope.$index, 'payMoney', true)"
                  @blur="tdInputNumber('tableData', scope.$index, 'payMoney', false)"
                ></el-input>
                <span v-else>{{ scope.row.payMoney.toLocaleString() }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.adjustment')">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.adjustment"
                  v-if="scope.$index != tableData.length - 1"
                  @input="tdInputNumber('tableData', scope.$index, 'adjustment', true)"
                  @blur="tdInputNumber('tableData', scope.$index, 'adjustment', false)"
                ></el-input>
                <span v-else>{{ scope.row.adjustment.toLocaleString() }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.otherOffset')">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.offset.payAmount"
                  v-if="scope.$index != tableData.length - 1"
                  :ref="'offsetInput' + scope.row.uuid"
                  @focus="openOffsetDialog(scope.row, 'tableData', scope.$index)"
                >
                  <i slot="prefix" class="el-input__icon el-icon-edit"></i>
                </el-input>
                <span v-else>{{ scope.row.offset.payAmount.toLocaleString() }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$locale('accountPayable.th.accountPayableBalance')">
              <template slot-scope="scope">{{ scope.row.actualAmountResidual.toLocaleString() }}</template>
            </el-table-column>
          </el-table>

          <div class="other-table-box" v-if="otherTableData.length > 0">
            <div class="other-table-tit">{{ $locale("accountPayable.otherPurchaseDetail") }}</div>
            <el-table :data="otherTableData" class="egl-table" stripe :cell-class-name="setOtherTableCellClassName">
              <el-table-column :label="$locale('global.cinemaName')" prop="cinemaName"></el-table-column>
              <el-table-column :label="$locale('accountPayable.customerName')" prop="clientName"></el-table-column>
              <el-table-column :label="$locale('global.name')" prop="showName"></el-table-column>

              <el-table-column :label="$locale('accountPayable.targetPeriod')" prop="dateInterval" v-if="tableData.length > 0"></el-table-column>
              <el-table-column :label="$locale('accountPayable.th.requestDeadDate')" prop="requestDeadDateText" v-else></el-table-column>

              <el-table-column :label="$locale('accountPayable.th.recordAmount')">
                <template slot-scope="scope">{{ scope.row.needPayAmount.toLocaleString() }}</template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.th.amountPaid')">
                <template slot-scope="scope">{{ scope.row.payAmount.toLocaleString() }}</template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.payMoney')">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.payMoney"
                    v-if="scope.$index != otherTableData.length - 1"
                    @input="tdInputNumber('otherTableData', scope.$index, 'payMoney', true)"
                    @blur="tdInputNumber('otherTableData', scope.$index, 'payMoney', false)"
                  ></el-input>
                  <span v-else>{{ scope.row.payMoney.toLocaleString() }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.adjustment')">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.adjustment"
                    v-if="scope.$index != otherTableData.length - 1"
                    @input="tdInputNumber('otherTableData', scope.$index, 'adjustment', true)"
                    @blur="tdInputNumber('otherTableData', scope.$index, 'adjustment', false)"
                  ></el-input>
                  <span v-else>{{ scope.row.adjustment.toLocaleString() }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.otherOffset')">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.offset.payAmount"
                    v-if="scope.$index != otherTableData.length - 1"
                    :ref="'offsetInput' + scope.row.uuid"
                    @focus="openOffsetDialog(scope.row, 'otherTableData', scope.$index)"
                  >
                    <i slot="prefix" class="el-input__icon el-icon-edit"></i>
                  </el-input>
                  <span v-else>{{ scope.row.offset.payAmount.toLocaleString() }}</span>
                </template>
              </el-table-column>

              <el-table-column :label="$locale('accountPayable.th.accountPayableBalance')">
                <template slot-scope="scope">{{ scope.row.actualAmountResidual.toLocaleString() }}</template>
              </el-table-column>
            </el-table>
          </div>

          <div class="table-total">
            <div class="clearfix">
              <span>{{ $locale("accountPayable.payMoneyTotal") }}</span>
              <span>{{ payMoneyTotal.toLocaleString() }}</span>
            </div>
            <div class="clearfix">
              <span>{{ $locale("accountPayable.paymentAmountDifference") }}</span>
              <span :class="paymentTotalText < 0 ? 'red-text' : ''">{{ paymentTotalText.toLocaleString() }}</span>
            </div>
            <div class="clearfix">
              <span>{{ $locale("accountPayable.threeTotal") }}</span>
              <span>{{ threeTotal.toLocaleString() }}</span>
            </div>
            <div class="clearfix payable-account">
              <span>{{ $locale("accountPayable.th.accountPayableBalance") }}{{ $locale("global.total") }}</span>
              <span>{{ accountPayableBalanceTotal.toLocaleString() }}</span>
            </div>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="egl-btn-white" @click="closeDialog">{{ $locale("global.cancel") }}</el-button>
        <el-button :class="saveBtnDisabled ? 'egl-btn-gray' : 'egl-btn-yellow'" @click="save_fn" :disabled="saveBtnDisabled || actionType == 'view'">{{ $locale("global.save") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommDatePicker from "@/components/common/CommDatePicker";
import {
  formatPaymentTableData,
  createPaymentForm,
  createPaymentTypeOption,
  getKeyNames,
} from "@/assets/js/accountPayable.js";
import { createAccountPayablePayment, updateAccountPayablePayment, getAccountReceivableListMap } from "@/helpers/service/api/accountPayable.js";
import { mapState, mapActions } from "vuex";
import { getClientListService } from "@/helpers/service/api/common";
import { getApiKeysField } from "@/utils/getApiKeys";

import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getBankAccountList } from "@/helpers/service/api/accountReceivable";
export default {
  name: "AccountPayablePaymentRegistration",
  inject: [ "accReceivableList" ],
  data() {
    return {

      dialogTitle: "",
      basicInfo: {},
      form: createPaymentForm(),
      paymentTotal: "",
      saveBtnDisabled: true,
      tableData: [],
      otherTableData: [],
      typeOption: [],
      typeDetailOption: [],
      payMoneyTotal: 0,
      accountPayableBalanceTotal: 0,
      paymentTotalText: 0,
      threeTotal: 0,
      payOffsetCinemaOption: [],
      offsetTag: {
        tableDataName: "",
        index: -1,
      },
      comAccRList: [],
      getApiKeysField,
    };
  },
  computed: {
    ...mapState("app", {
      brandId: state => state.brandId,
      accountReceivablePar: state => `brandId=${state.brandId}&page=0&pageSize=9999&field=name&field=id&field=needPayAmount&field=targetSourceList`
    }),
    ...mapState("api", {
      clientList: state => state.clientList,
      cinemaList: state => state.cinemaList,
      bankAccountList: state => state.bankAccountList,
      accountReceivableList: state => state.invoiceList,
    }),
    injectAccRlist() {
      return this.accReceivableList();
    }
  },
  methods: {
    ...mapActions("accountPayable", [ "setOffsetHistory" ]),
    ...mapActions("api", ["setBankAccountList", "setInvoiceList"]),
    closeDialog() {
      this.$emit("closeFn");
      this.$emit("refreshTable", undefined, false);
    },
    save_fn() {
      let obj = JSON.parse(JSON.stringify(this.form));

      obj.brandId = this.brandId;
      obj.accountPayableId = this.accountPayableMsg.id;
      obj.payAmount = this.threeTotal;
      obj.actualAmountResidual = this.accountPayableBalanceTotal;
      obj.payMoney = this.payMoneyTotal;
      obj.payableType = this.accountPayableMsg.type;

      if (this.tableData.length > 0) {
        for (let i = 0; i < this.tableData.length - 1; i++) {
          obj.payDetails.push({ ...this.tableData[i] });
        }
      }

      if (this.otherTableData.length > 0) {
        for (let i = 0; i < this.otherTableData.length - 1; i++) {
          obj.payDetails.push({ ...this.otherTableData[i] });
        }
      }

      if (this.actionType == "create") {
        createAccountPayablePayment([ obj ]).then(res => {
          if (res.success) {
            this.$emit("closeFn");
            this.$emit("refreshTable");
          }
        });
      } else {
        obj.id = this.formMsg.id;

        updateAccountPayablePayment(obj).then(res => {
          if (res.success) {
            this.$emit("refreshList");
            this.$emit("refreshTable");
          }
        });
      }
    },
    setSaveBtn(tableType = "") {
      let saveBtnDisabled = true;
      let obj = { ...this.form };

      if (tableType != "") {
        // att => Active Table Total
        const { needPayAmount: att_needPayAmount, payAmount: att_payAmount } = this[tableType][this[tableType].length - 1];
        let att_payMoney = 0;
        let att_adjustment = 0;
        let att_offset = 0;
        let att_actualAmountResidual = 0;

        let payMoneyTotal = 0;
        let paymentTotalText = 0;
        let threeTotal = 0;
        let accountPayableBalanceTotal = 0;

        let { paymentTotal } = this;

        for (let i = 0; i < this[tableType].length - 1; i++) {
          att_payMoney += parseInt(this[tableType][i].payMoney.toString().replace(/[^\d-]/g, "")) || 0;
          att_adjustment += parseInt(this[tableType][i].adjustment.toString().replace(/[^\d-]/g, "")) || 0;
          att_offset += parseInt(this[tableType][i].offset.payAmount.toString().replace(/[^\d-]/g, "")) || 0;
        }

        att_actualAmountResidual = att_needPayAmount - att_payAmount - att_payMoney - att_adjustment - att_offset;

        this[tableType][this[tableType].length - 1].payMoney = att_payMoney;
        this[tableType][this[tableType].length - 1].adjustment = att_adjustment;
        this[tableType][this[tableType].length - 1].offset.payAmount = att_offset;
        this[tableType][this[tableType].length - 1].actualAmountResidual = att_actualAmountResidual;

        if (this.tableData.length > 0) {
          payMoneyTotal += this.tableData[this.tableData.length - 1].payMoney;
          threeTotal = threeTotal + this.tableData[this.tableData.length - 1].payMoney + this.tableData[this.tableData.length - 1].adjustment + this.tableData[this.tableData.length - 1].offset.payAmount;
          accountPayableBalanceTotal += this.tableData[this.tableData.length - 1].actualAmountResidual;
        }

        if (this.otherTableData.length > 0) {
          payMoneyTotal += this.otherTableData[this.otherTableData.length - 1].payMoney;
          threeTotal = threeTotal + this.otherTableData[this.otherTableData.length - 1].payMoney + this.otherTableData[this.otherTableData.length - 1].adjustment + this.otherTableData[this.otherTableData.length - 1].offset.payAmount;
          accountPayableBalanceTotal += this.otherTableData[this.otherTableData.length - 1].actualAmountResidual;
        }

        paymentTotalText = payMoneyTotal - paymentTotal;

        this.payMoneyTotal = payMoneyTotal;
        this.paymentTotalText = paymentTotalText;
        this.threeTotal = threeTotal;
        this.accountPayableBalanceTotal = accountPayableBalanceTotal;
      }

      if (obj.name && obj.type && this.paymentTotal && this.paymentTotalText == 0) {
        saveBtnDisabled = false;
      }

      this.saveBtnDisabled = saveBtnDisabled;
    },
    async changeType() {
      let typeDetailOption = [];
      let typeDetail = "";
      let bankAccountId = "";
      let payOffset = {
        id: "",
        offsetDetailId: "",
        offsetDetail: "",
      };
      let payOffsetCinemaOption = [];

      switch (this.form.type) {
      case "ACCOUNT":
        this.setBankAccountList((await getBankAccountList()).data);
        this.typeOption[0].child = this.bankAccountList.map(item => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        break;

      case "OFFSET":
        this.setInvoiceList((await getAccountReceivableListMap(this.accountReceivablePar)).data.data);
        this.typeOption[1].child = this.accountReceivableList.map(item => {
          return {
            label: item.name,
            value: item.id,
            child: getKeyNames(item.operationType).reduce((prev, keyName) => {
              return [...prev,
                ...item.targetSourceList[keyName].detail.map(secItem => ({ value: secItem.uuid, label: secItem.showName }))];
            }, [])
          };
        });
        break;

      default:
        break;
      }

      if (this.actionType == "view" || this.actionType == "edit") {
        typeDetailOption = this.typeOption.find(option => option.value === this.form.type).child;
        payOffsetCinemaOption = this.form.type === "OFFSET" ? [] : typeDetailOption.find(option => {
          return option.value === this.form.typeDetail;
        });
      }

      typeDetailOption = this.typeOption.find(option => option.value === this.form.type).child;
      typeDetail = typeDetailOption[0].value;

      if (this.form.type == "ACCOUNT") {
        bankAccountId = typeDetail;
      }

      if (this.form.type == "OFFSET") {
        payOffset.id = typeDetailOption[0].value;
        payOffset.offsetDetail = typeDetailOption[0].child[0].label;
        payOffset.offsetDetailId = typeDetailOption[0].child[0].value;
        payOffsetCinemaOption = [ ...typeDetailOption[0].child ];
      }

      this.form = {
        ...this.form,
        typeDetail,
        bankAccountId,
        payOffset,
      };
      this.typeDetailOption = typeDetailOption;
      this.payOffsetCinemaOption = payOffsetCinemaOption;
      this.setSaveBtn();
    },
    changeTypeDetail() {
      if (this.form.type == "OFFSET") {
        let { typeDetail } = this.form;
        let payOffset = {
          id: "",
          offsetDetail: "",
          offsetDetailId: "",
        };

        for (let i = 0; i < this.typeDetailOption.length; i++) {
          if (typeDetail == this.typeDetailOption[i].value) {
            payOffset.id = typeDetail;
            payOffset.offsetDetail = this.typeDetailOption[i].child[0].label;
            payOffset.offsetDetailId = this.typeDetailOption[i].child[0].value;

            this.payOffsetCinemaOption = [ ...this.typeDetailOption[i].child ];
            this.form = {
              ...this.form,
              payOffset: payOffset,
            };
            break;
          }
        }
      }

      if (this.form.type == "ACCOUNT") {
        this.form.bankAccountId = this.form.typeDetail;
      }
    },
    changePayOffset() {
      for (let i = 0; i < this.payOffsetCinemaOption.length; i++) {
        if (this.form.payOffset.offsetDetailId == this.payOffsetCinemaOption[i].value) {
          this.form.payOffset.offsetDetail = this.payOffsetCinemaOption[i].label;
          break;
        }
      }
    },
    inputPaymentTotal() {
      let num = this.paymentTotal;
      const { payMoneyTotal } = this;

      num = num.replace(/[^\d.-]/g, "");

      this.paymentTotal = num;

      num = parseFloat(num) || 0;

      this.paymentTotalText = payMoneyTotal - num;
      this.setSaveBtn();
    },
    blurPaymentTotal() {
      let num = this.paymentTotal;
      const { payMoneyTotal } = this;

      num = parseFloat(num) || 0;

      this.paymentTotal = num;
      this.paymentTotalText = payMoneyTotal - num;
      this.setSaveBtn();
    },
    setCellClassName({ rowIndex, columnIndex }) {
      let dataLength = this.tableData.length;

      if (rowIndex < dataLength - 1) {
        if (columnIndex >= 4) {
          return "ta-r";
        }
      }
    },
    setOtherTableCellClassName({ rowIndex, columnIndex }) {
      let dataLength = this.otherTableData.length;

      if (rowIndex < dataLength - 1) {
        if (columnIndex >= 4) {
          return "ta-r";
        }
      }
    },
    copyAllTrPayable() {
      let tableData = [ ...this.tableData ];
      let otherTableData = [ ...this.otherTableData ];

      let payMoneyTotal = 0;
      let paymentTotalText = 0;
      let threeTotal = 0;

      let paymentTotal = this.paymentTotal || 0;

      if (tableData.length > 0) {
        tableData.map((item, index) => {
          item.payMoney = item.payMoney + item.actualAmountResidual;
          item.actualAmountResidual = 0;
        });

        payMoneyTotal += tableData[tableData.length - 1].payMoney;
        threeTotal = threeTotal + tableData[tableData.length - 1].payMoney + tableData[tableData.length - 1].adjustment + tableData[tableData.length - 1].offset.payAmount;
      }

      if (otherTableData.length > 0) {
        otherTableData.map((item, index) => {
          item.payMoney = item.payMoney + item.actualAmountResidual;
          item.actualAmountResidual = 0;
        });

        payMoneyTotal += otherTableData[otherTableData.length - 1].payMoney;
        threeTotal = threeTotal + otherTableData[otherTableData.length - 1].payMoney + otherTableData[otherTableData.length - 1].adjustment + otherTableData[otherTableData.length - 1].offset.payAmount;
      }

      paymentTotalText = payMoneyTotal - paymentTotal;

      this.payMoneyTotal = payMoneyTotal;
      this.paymentTotalText = paymentTotalText;
      this.threeTotal = threeTotal;
      this.accountPayableBalanceTotal = 0;

      this.setSaveBtn();
    },
    tdInputNumber(tableType = "tableData", index, keyName, isInput = true) {
      const { needPayAmount, payAmount, offset } = this[tableType][index];
      let { payMoney, adjustment } = this[tableType][index];
      let actualAmountResidual = 0;
      let num = this[tableType][index][keyName];

      payMoney = parseInt(payMoney.toString().replace(/[^\d-]/g, "")) || 0;
      adjustment = parseInt(adjustment.toString().replace(/[^\d-]/g, "")) || 0;
      actualAmountResidual = needPayAmount - payAmount - payMoney - adjustment - offset.payAmount;

      num = num.toString().replace(/[^\d-]/g, "");

      if (!isInput) {
        num = parseInt(num) || 0;
      }

      this[tableType][index].payMoney = payMoney;
      this[tableType][index].adjustment = adjustment;
      this[tableType][index].actualAmountResidual = actualAmountResidual;
      this[tableType][index][keyName] = num;

      this.setSaveBtn(tableType);
    },
    openOffsetDialog(obj, tableDataName, index) {
      const trOffset = JSON.parse(JSON.stringify(this[tableDataName][index].offset));
      let dialogObj = {
        cinemaName: obj.cinemaName,
        clientName: obj.clientName,
        filmName: obj.filmName || "",
        time: obj.dateInterval || "",
        actualAmountResidual: obj.actualAmountResidual,
      };

      let enteredMsg = {
        invoice: [],
        revenue: [],
        other: [],
        payAmount: 0,
        ...trOffset,
      };

      this.offsetTag = {
        ...this.offsetTag,
        tableDataName: tableDataName,
        index: index,
      };
      this.setOffsetHistory(enteredMsg);
      this.$refs["offsetInput" + obj.uuid].blur();
      this.$emit("openOffsetDialog", dialogObj);
    },
    setOffset(obj) {
      const { tableDataName, index } = this.offsetTag;

      const { needPayAmount, payAmount, payMoney, adjustment } = this[tableDataName][index];

      this[tableDataName][index].offset = { ...obj };
      this[tableDataName][index].actualAmountResidual = needPayAmount - payAmount - payMoney - adjustment - obj.payAmount;

      this.setSaveBtn(tableDataName);
    },
  },
  // mounted() {},
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    formMsg: {
      type: Object,
      default: () => {},
    },
    accountPayableMsg: {
      type: Object,
      default: () => {},
    },
    actionType: {
      type: String,
      default: () => "create",
    },
  },
  components: {
    CommDatePicker,
    RemoteSelectV2
  },
  watch: {
    async isShow() {
      if (this.isShow) {
        this.comAccRList = this.injectAccRlist;
        let targetSourceListKeyName = [];
        const basicInfo = {
          name: this.accountPayableMsg.name,
          requestDeadDateText: this.$moment(this.accountPayableMsg.requestDeadDate).format("YYYY-MM-DD"),
          payDateText: this.$moment(this.accountPayableMsg.payDate).format("YYYY-MM-DD"),
          needPayAmountText: this.accountPayableMsg.needPayAmount.toLocaleString(),
        };
        let dialogTitle = this.$locale("accountPayable.payment");
        let typeOption = createPaymentTypeOption();
        let { tableData, otherTableData } = formatPaymentTableData(this.accountPayableMsg, this.cinemaList, this.clientList, this.formMsg.payDetails);

        let form = createPaymentForm();
        let payMoneyTotal = 0;
        let paymentTotalText = 0;
        let threeTotal = 0;
        let accountPayableBalanceTotal = 0;
        let paymentTotal = "";

        this.bankAccountList.map(item => {
          typeOption[0].child.push({
            label: item.name,
            value: item.id,
          });
        });
        this.comAccRList.map(item => {
          let obj = {
            label: item.name,
            value: item.id,
            child: [],
          };

          targetSourceListKeyName = getKeyNames(item.operationType);
          targetSourceListKeyName.map(keyName => {
            item.targetSourceList[keyName].detail.map(secItem => {
              obj.child.push({
                label: secItem.showName,
                value: secItem.uuid,
              });
            });
          });
          typeOption[1].child.push(obj);
        });

        if (tableData.length > 0) {
          payMoneyTotal = tableData[tableData.length - 1].payMoney;
          threeTotal = payMoneyTotal + tableData[tableData.length - 1].adjustment + tableData[tableData.length - 1].offset.payAmount;
          accountPayableBalanceTotal = tableData[tableData.length - 1].actualAmountResidual;
        }

        if (otherTableData.length > 0) {
          payMoneyTotal = payMoneyTotal + otherTableData[otherTableData.length - 1].payMoney;
          threeTotal = payMoneyTotal + otherTableData[otherTableData.length - 1].adjustment + otherTableData[otherTableData.length - 1].offset.payAmount;
          accountPayableBalanceTotal = accountPayableBalanceTotal + otherTableData[otherTableData.length - 1].actualAmountResidual;
        }

        if (this.actionType == "create") {
          dialogTitle += this.$locale("global.registration");
        }

        if (this.actionType == "edit") {
          dialogTitle += this.$locale("global.edit");
        }

        if (this.actionType == "view" || this.actionType == "edit") {
          form.name = this.formMsg.name;
          form.date = this.formMsg.date;
          form.type = this.formMsg.type;
          form.typeDetail = this.formMsg.typeDetail;
          form.bankAccountId = this.formMsg.bankAccountId;
          form.payOffset = { ...this.formMsg.payOffset };

          paymentTotal = payMoneyTotal;
        }


        this.dialogTitle = dialogTitle;
        this.basicInfo = basicInfo;
        this.typeOption = createPaymentTypeOption();
        this.tableData = tableData;
        this.otherTableData = otherTableData;
        this.form = form;
        this.payMoneyTotal = payMoneyTotal;
        this.paymentTotalText = paymentTotalText;
        this.threeTotal = threeTotal;
        this.accountPayableBalanceTotal = accountPayableBalanceTotal;
        this.paymentTotal = paymentTotal;
        // mapping clientName
        const ids = this.accountPayableMsg.targetSourceList.elseBuy ?
          this.accountPayableMsg.targetSourceList.elseBuy.map(item => item.clientId) : [];
        if (ids.length > 0) {
          getClientListService({
            ids,
            page: 0,
            pageSize: 9999,
            field: ["id", "name"]
          }).then(res => {
            const clientList = res.data.data;
            this.otherTableData.forEach(item => {
              item.clientName = clientList.find(item => item.id).name;
            });
          });
        }
      }
    },
  },
};
</script>
